(function(){
  'use strict';

  var desktopStateTimers=new WeakMap();

  function goBack(){
    if(window.history.length>1){
      window.history.back();
    }else{
      window.location.assign('/');
    }
  }

  function genreItems(item){
    if(!item||!item.parentElement)return[];
    return Array.prototype.filter.call(item.parentElement.children,function(child){
      return child.classList&&child.classList.contains('child-nav__item--toggle');
    });
  }

  function setGenreState(item,open,closeSiblings){
    if(!item)return;
    var button=item.querySelector(':scope > .main-nav__item-content > .js-toggle');
    item.classList.toggle('is-open',open);
    if(button)button.setAttribute('aria-expanded',open?'true':'false');

    if(open&&closeSiblings){
      genreItems(item).forEach(function(sibling){
        if(sibling===item)return;
        var timer=desktopStateTimers.get(sibling);
        if(timer)window.clearTimeout(timer);
        desktopStateTimers.delete(sibling);
        sibling.classList.remove('is-open');
        var siblingButton=sibling.querySelector(':scope > .main-nav__item-content > .js-toggle');
        if(siblingButton)siblingButton.setAttribute('aria-expanded','false');
      });
    }
  }

  function setMobileGenreState(item,open){
    if(!item)return;
    var button=item.querySelector(':scope > .main-nav__item-content > .js-toggle');
    var panel=item.querySelector(':scope > .child-nav__panel');
    if(!button||!panel)return;

    button.setAttribute('aria-expanded',open?'true':'false');
    if(open){
      item.classList.add('is-open');
      panel.style.height='0px';
      window.requestAnimationFrame(function(){panel.style.height=panel.scrollHeight+'px';});
    }else{
      panel.style.height=panel.scrollHeight+'px';
      window.requestAnimationFrame(function(){panel.style.height='0px';});
      window.setTimeout(function(){
        if(button.getAttribute('aria-expanded')==='false'){
          item.classList.remove('is-open');
          panel.style.height='';
        }
      },320);
    }
  }

  function setMobileMenuState(button,open){
    if(!button)return;
    var panel=document.getElementById(button.getAttribute('aria-controls'));
    if(!panel)return;
    var item=button.closest('.child-nav__item--toggle, .main-nav__item--dropdown');

    button.setAttribute('aria-expanded',open?'true':'false');
    if(open){
      if(item)item.classList.add('is-open');
      panel.style.setProperty('height','0px','important');
      panel.style.setProperty('max-height','0px','important');
      window.requestAnimationFrame(function(){
        var targetHeight=panel.scrollHeight+'px';
        panel.style.setProperty('height',targetHeight,'important');
        panel.style.setProperty('max-height',targetHeight,'important');
      });
    }else{
      panel.style.setProperty('height',panel.scrollHeight+'px','important');
      panel.style.setProperty('max-height',panel.scrollHeight+'px','important');
      window.requestAnimationFrame(function(){
        panel.style.setProperty('height','0px','important');
        panel.style.setProperty('max-height','0px','important');
      });
      window.setTimeout(function(){
        if(button.getAttribute('aria-expanded')==='false'&&item){
          item.classList.remove('is-open');
        }
      },320);
    }
  }

  function restrictShippingCountries(root){
    var scope=root&&root.querySelectorAll?root:document;
    var selectors=[
      'shipping-calculator select[name="address[country]"]',
      'shipping-calculator select[name="country"]',
      '.shipping-calculator select[name="address[country]"]',
      '#shipping-calculator select[name="address[country]"]',
      'select[data-country-selector]',
      '#cart-drawer-shipping-country',
      'select.js-country-select'
    ];

    scope.querySelectorAll(selectors.join(',')).forEach(function(select){
      if(select.dataset.dsIndiaOnly==='true')return;
      var indiaOption=Array.prototype.find.call(select.options,function(option){
        return option.value==='India'||option.text.trim()==='India'||option.value==='IN';
      });
      if(!indiaOption)return;

      Array.prototype.slice.call(select.options).forEach(function(option){
        if(option!==indiaOption)option.remove();
      });
      indiaOption.selected=true;
      select.value=indiaOption.value;
      select.dataset.dsIndiaOnly='true';
      select.dispatchEvent(new Event('change',{bubbles:true}));
    });
  }

  function scheduleDesktopState(item,open){
    var existing=desktopStateTimers.get(item);
    if(existing)window.clearTimeout(existing);
    var delay=open?220:320;
    var timer=window.setTimeout(function(){
      desktopStateTimers.delete(item);
      setGenreState(item,open,open);
    },delay);
    desktopStateTimers.set(item,timer);
  }

  function syncArrowClick(button){
    window.setTimeout(function(){
      var item=button.closest('.child-nav__item--toggle');
      if(!item)return;
      var timer=desktopStateTimers.get(item);
      if(timer)window.clearTimeout(timer);
      desktopStateTimers.delete(item);
      var desktop=window.matchMedia('(min-width: 769px)').matches;
      setGenreState(item,button.getAttribute('aria-expanded')==='true',desktop);
    },0);
  }

  document.addEventListener('pointerover',function(event){
    if(!window.matchMedia('(min-width: 769px) and (hover: hover)').matches)return;
    var item=event.target.closest('.child-nav__item--toggle');
    if(!item||!item.closest('.main-menu'))return;
    if(event.relatedTarget&&item.contains(event.relatedTarget))return;
    scheduleDesktopState(item,true);
  });

  document.addEventListener('pointerout',function(event){
    if(!window.matchMedia('(min-width: 769px) and (hover: hover)').matches)return;
    var item=event.target.closest('.child-nav__item--toggle');
    if(!item||!item.closest('.main-menu'))return;
    if(event.relatedTarget&&item.contains(event.relatedTarget))return;
    scheduleDesktopState(item,false);
  });

  window.addEventListener('click',function(event){
    var genreToggle=event.target.closest('.main-nav__toggle-btn.js-toggle[aria-controls]');
    if(genreToggle&&genreToggle.closest('.main-menu')&&window.matchMedia('(max-width: 768px)').matches){
      event.preventDefault();
      event.stopImmediatePropagation();
      setMobileMenuState(genreToggle,genreToggle.getAttribute('aria-expanded')!=='true');
      return;
    }

    var desktopGenreToggle=event.target.closest('.child-nav__item--toggle > .main-nav__item-content > .js-toggle');
    if(desktopGenreToggle){
      syncArrowClick(desktopGenreToggle);
    }

    var backButton=event.target.closest('[data-ds-page-back]');
    if(!backButton)return;
    event.preventDefault();
    goBack();
  },true);

  function startStorefrontGuards(){
    restrictShippingCountries(document);
    var observer=new MutationObserver(function(records){
      records.forEach(function(record){
        record.addedNodes.forEach(function(node){
          if(node.nodeType===1)restrictShippingCountries(node);
        });
      });
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',startStorefrontGuards,{once:true});
  }else{
    startStorefrontGuards();
  }
})();
